// Import Dependencies
import { Navigate } from "react-router";

// Local Imports
import { DynamicLayout } from "app/layouts/DynamicLayout";
import AuthGuard from "middleware/AuthGuard";

// ----------------------------------------------------------------------

const protectedRoutes = {
  id: "protected",
  Component: AuthGuard,
  children: [
    // The dynamic layout supports both the main layout and the sideblock.
    {
      Component: DynamicLayout,
      children: [
        {
          index: true,
          element: <Navigate to="/lead-user/applications" />,
        },
        {
          path: "notifications",
          lazy: async () => ({
            Component: (await import("components/template/NotificationsPage.jsx")).default,
          }),
        },
        {
          path: "no-access",
          lazy: async () => ({
            Component: (await import("app/pages/NoAccess")).default,
          }),
        },
        {
          path: "lead-user",
          children: [
            {
              index: true,
              element: <Navigate to="/lead-user/applications" />,
            },

            {
              path: "applications",
              lazy: async () => ({
                Component: (
                  await import("app/pages/leadUserView/ApplicationListing")
                ).default,
              }),
            },
            {
              path: "applications/:applicationId",
              lazy: async () => ({
                Component: (
                  await import("app/pages/leadUserView/ApplicationDetails")
                ).default,
              }),
            },
            {
              path: "applications/:applicationId/queries",
              lazy: async () => ({
                Component: (
                  await import("app/pages/leadUserView/LeadQueries")
                ).default,
              }),
            },
            {
              path: "dashboard",
              lazy: async () => ({
                Component: (
                  await import("app/pages/leadUserView/Dashboard")
                ).default,
              }),
            },
            {
              path: "raise-query",
              lazy: async () => ({
                Component: (
                  await import("app/pages/leadUserView/RaiseQuery")
                ).default,
              }),
            },
            {
              path: "enquiry-queries",
              lazy: async () => ({
                Component: (
                  await import("app/pages/leadUserView/EnquiryQueries")
                ).default,
              }),
            },
          ],
        },
        {
          path: "settings",
          lazy: async () => ({
            Component: (await import("app/pages/settings/Layout")).default,
          }),
          children: [
            {
              index: true,
              element: <Navigate to="/settings/profile" />,
            },
           
            {
              path: "appearance",
              lazy: async () => ({
                Component: (
                  await import("app/pages/settings/sections/appearance/Appearance")
                ).default,
              }),
            },
             {
              path: "profile",
              lazy: async () => ({
                Component: (
                  await import("app/pages/leadUserView/LeadProfile")
                ).default,
              }),
            },
          ],
        },

      ],
    },
  ],
};

export { protectedRoutes };
